import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

const API_BASE_URL =
  process.env.VUE_APP_API_BASE_URL || "https://api.lostbeasts.net";

// 添加调试日志
console.log("API Base URL:", API_BASE_URL);
console.log("Node ENV:", process.env.NODE_ENV);

// 创建axios实例
const service: AxiosInstance = axios.create({
  baseURL: API_BASE_URL, // 直接使用硬编码的 URL
  timeout: 15000,
  //   headers: {
  //     "Content-Type": "application/json",
  //     Accept: "application/json",
  //   },
  //   headers: {
  //     "Content-Type": "application/json;charset=utf-8",
  //   },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("nft-token")) {
      config.headers["Authorization"] = localStorage.getItem("nft-token");
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response: AxiosResponse) => {
    // console.log("response.headers:", response.headers["authorization"]);
    console.log("---------", response);
    const res = response.data;
    if (response.headers && response.headers["authorization"]) {
      localStorage.setItem(
        "nft-token",
        response.headers["authorization"] || response.headers["Authorization"]
      );
    }
    // 这里可以根据后端约定的状态码判断请求是否成功
    if (res.code === 200) {
      return res;
    }
    // 处理其他状态码
    return Promise.reject(new Error(res.message || "请求失败"));
  },
  (error) => {
    // 处理错误响应
    return Promise.reject(error);
  }
);

export default service;
